
import { i18nText } from '@/locales';
import { RouterNameEnum } from "@/router/router.types";
export const VisitsNewRoutes = [
    {
        path: "/visitsnew",
        redirect: "visitsnew/index",
        component: (): any => import("@/UI/layouts/MainLayout.vue"),
        meta: {
            alias: RouterNameEnum.VisitsNew,
            auth: true,
        },
        children: [
            {
                path: "Records/Current/:Studio",
                component: (): any => import("@/UI/pages/visitsNew/index.vue"),
                name: RouterNameEnum.VisitsNew,

                meta: {
                    alias: RouterNameEnum.VisitsNew,
                    title: i18nText("новый Журнал записи - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Журнал записи"), link: 'VisitsNew', support: ["studioselect"] }
                    ],
                    props: { mode: "current" },
                },
            },
            {
                path: "Records/Date/:Date/:Studio",
                component: (): any => import("@/UI/pages/visitsNew/index.vue"),
                name: RouterNameEnum.VisitsNewDate,

                meta: {
                    alias: RouterNameEnum.VisitsNew,
                    title: i18nText("новый Журнал записи - EPILIER"),
                    breadcrumb: [
                        { name: i18nText("Журнал записи"), link: 'VisitsNew', support: ["studioselect"] }
                    ],
                    props: { mode: "value" },
                },
            },

            {
                path: "Records/Current/:Studio/:Worker/:mode/:params",
                name: RouterNameEnum.VisitsNewRecord,
                component: (): any => import("@/UI/pages/visitsNew/Dialogs/Visit.vue"),
                meta: {
                    alias: RouterNameEnum.VisitsNew,
                    title: i18nText("Запись клиента"),
                    breadcrumb: [
                        { name: i18nText("Журнал записи"), link: 'VisitsNew', support: ["studioselect"] },
                        { name: i18nText("Запись клиента"), support: ["submitButton", "deleteButton", "closeButton"] },
                    ],
                },
                children: [
                    {
                        path: "Detail/:id",
                        name: RouterNameEnum.VisitsNewDetail,
                        component: (): any => import("@/UI/pages/visitsNew/Pages/Create.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("Данные визита"),
                            breadcrumb: [
                                { name: i18nText("Запись клиента"), support: ["submitButton", "deleteButton", "closeButton"] },
                            ],
                        },
                        children: [
                            {
                                path: "Debt",
                                name: RouterNameEnum.VisitsNewDebt,
                                component: (): any => import("@/UI/pages/visitsNew/Dialogs/Debt.vue"),
                                meta: {
                                    alias: RouterNameEnum.VisitsNew,
                                    title: i18nText("Оплата долга"),
                                    breadcrumb: [
                                        { name: i18nText("Оплата долга") },
                                    ],
                                },
                            },
                            {
                                path: "Service",
                                name: RouterNameEnum.VisitsNewService,
                                component: (): any => import("@/UI/pages/visitsNew/Dialogs/Service.vue"),
                                meta: {
                                    alias: RouterNameEnum.VisitsNew,
                                    title: i18nText("Добавить услуги"),
                                    breadcrumb: [
                                        { name: i18nText("Создание визита"), support: ["submitButton", "closeButton"] },
                                    ],
                                },
                            },
                        ],
                    },

                    {
                        path: "Status/:id",
                        name: RouterNameEnum.VisitsNewStatus,
                        component: (): any => import("@/UI/pages/visitsNew/Pages/Status.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("Статус визита"),
                        },

                        children: [
                            {
                                path: "AddCertificate",
                                name: RouterNameEnum.VisitsNewStatusAddCertificate,
                                component: (): any => import("@/UI/pages/visitsNew/Dialogs/Cert.vue"),
                                meta: {
                                    alias: RouterNameEnum.VisitsNew,
                                    title: i18nText("Добавить сертификат"),
                                    breadcrumb: [
                                        { name: i18nText("Создание визита") },
                                    ],
                                },
                            },
                        ],
                    },

                    {
                        path: "StatusFm/:id/:event/:isNew",
                        name: RouterNameEnum.VisitsNewStatusFm,
                        component: (): any => import("@/UI/pages/visitsNew/Pages/Status.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("Статус визита"),
                            breadcrumb: [
                                { name: i18nText("Создание визита") },
                            ],
                        },

                        children: [
                            {
                                path: "AddCertificate",
                                name: RouterNameEnum.VisitsNewStatusAddCertificate,
                                component: (): any => import("@/UI/pages/visitsNew/Dialogs/Cert.vue"),
                                meta: {
                                    alias: RouterNameEnum.VisitsNew,
                                    title: i18nText("Добавить сертификат"),
                                    breadcrumb: [
                                        { name: i18nText("Создание визита") },
                                    ],
                                },
                            },
                        ],
                    },
                    {
                        path: "Pay/:id",
                        name: RouterNameEnum.VisitsNewPay,
                        component: (): any => import("@/UI/pages/visitsNew/Pages/Pay.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("Оплата визита"),
                        },
                    },
                    {
                        path: "Report/Pay/:form",
                        name: RouterNameEnum.VisitsNewPayReport,
                        component: (): any => import("@/UI/pages/visitsNew/Reports/Pay.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("Оплата визита"),
                            breadcrumb: [
                                { name: i18nText("Оплата визита"), support: ["closeButton"] },
                            ],
                        },
                    },

                    {
                        path: "History/:id",
                        name: RouterNameEnum.VisitsNewHistory,
                        component: (): any => import("@/UI/pages/visitsNew/Pages/History.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("История изменений"),
                            breadcrumb: [{ name: i18nText("История изменений") }],
                        },
                    },
                    {
                        path: "Products/:id",
                        name: RouterNameEnum.VisitsNewProducts,
                        component: (): any => import("@/UI/pages/visitsNew/Pages/Products.vue"),
                        meta: {
                            alias: RouterNameEnum.VisitsNew,
                            title: i18nText("Списание расходников"),
                        },
                    },
                ],
            },

            /*{
                path:'Records/:Studio/:Date',
                props:{date:'value'},
                name: RouterNameEnum.VisitsNewDate,
                meta: {
                    title: 'новый Журнал записи - EPILIER',
                    breadcrumb: [{ name: 'Журнал записи', link: RouterNameEnum.VisitsNew, support: ["studioselect"]  }],
                },
                component: (): any => import('@/UI/pages/visitsNew/index.vue'),

            }*/
        ],
    },
];
